import { render, staticRenderFns } from "./NavigationShortDetail.vue?vue&type=template&id=48a4b5b9"
import script from "./NavigationShortDetail.vue?vue&type=script&lang=js"
export * from "./NavigationShortDetail.vue?vue&type=script&lang=js"
import style0 from "./NavigationShortDetail.vue?vue&type=style&index=0&id=48a4b5b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports